import React from "react";
import { Modal } from "react-bootstrap";

const APPLICATION_INSTRUCTIONS_STYLES = {
  modalContent: {
    borderRadius: "26px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalDialog: {
    maxWidth: "1080px"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px"
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800,
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    maxHeight: "calc(100vh - 160px)",
    overflowY: "auto"
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px"
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px"
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0
  },
  sectionCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
    marginBottom: "16px"
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "6px"
  },
  sectionSubtitle: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    marginBottom: "14px"
  },
  sectionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "14px"
  },
  infoCard: {
    borderRadius: "18px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fbff",
    padding: "16px"
  },
  infoCardTitle: {
    fontSize: "13px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "10px"
  },
  bulletList: {
    margin: 0,
    paddingLeft: "18px",
    color: "#334155",
    fontSize: "13px",
    lineHeight: 1.75
  },
  numberList: {
    margin: 0,
    paddingLeft: "18px",
    color: "#334155",
    fontSize: "13px",
    lineHeight: 1.8
  },
  noteBox: {
    borderRadius: "18px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "linear-gradient(135deg, rgba(239,246,255,0.9) 0%, rgba(248,250,252,1) 100%)",
    padding: "16px"
  },
  noteTitle: {
    fontSize: "13px",
    fontWeight: 800,
    color: "#1d4ed8",
    marginBottom: "8px"
  },
  noteText: {
    fontSize: "13px",
    lineHeight: 1.75,
    color: "#334155",
    margin: 0
  }
};

const candidateSteps = (entityType) => {
  const steps = [
    {
      title: "Onboarding Form",
      text: "Complete the missing fields in the onboarding application form. All data fields are mandatory."
    },
    {
      title: "Contract Documents",
      text: "Upload the required documents and complete the listed forms. Some documents will be executed using DocuSign."
    }
  ];

  if (entityType !== "C2C Basis") {
    steps.push({
      title: "ACH Information",
      text: "Complete the ACH form and upload the signed form together with a copy of the voided check."
    });
  }

  steps.push(
    {
      title: "Background Check",
      text: "Complete client-specific background check requirements. You will be updated once results are received."
    },
    {
      title: "Reporting Details",
      text: "Review your reporting details for the project engagement."
    },
    {
      title: "Onboarding Status",
      text: "Check your latest onboarding progress and pending items."
    }
  );

  return steps;
};

const partnerSteps = [
  {
    title: "Onboarding Form",
    text: "Complete the missing fields in the onboarding application form. All data fields are mandatory."
  },
  {
    title: "Contract Documents",
    text: "Download and upload required contract documents and complete the listed forms. Some documents will be executed using DocuSign."
  },
  {
    title: "ACH Information",
    text: "Complete the ACH form and upload the signed form from an authorized company signatory, along with a copy of the voided check."
  },
  {
    title: "Insurance Information",
    text: "Enter company insurance coverage details and upload the certificate of insurance documents."
  },
  {
    title: "Onboarding Status",
    text: "Check the current onboarding progress for the engagement."
  }
];

const ApplicationInstructions = ({
  instructionShowHide,
  handleInstructionShowHide,
  entityType
}) => {
  const usrType = localStorage.getItem("userType");
  const isCandidate = usrType === "candidate";
  const steps = isCandidate ? candidateSteps(entityType) : partnerSteps;

  return (
    <Modal
      show={instructionShowHide}
      size="xl"
      centered
      onHide={handleInstructionShowHide}
      dialogClassName="application-instructions-modal-dialog"
      contentClassName="application-instructions-modal-content"
    >
      <style>
        {`
          .application-instructions-modal-dialog {
            max-width: ${APPLICATION_INSTRUCTIONS_STYLES.modalDialog.maxWidth};
          }
          .application-instructions-modal-content {
            border-radius: ${APPLICATION_INSTRUCTIONS_STYLES.modalContent.borderRadius};
            overflow: ${APPLICATION_INSTRUCTIONS_STYLES.modalContent.overflow};
            border: ${APPLICATION_INSTRUCTIONS_STYLES.modalContent.border};
            box-shadow: ${APPLICATION_INSTRUCTIONS_STYLES.modalContent.boxShadow};
          }
        `}
      </style>

      <Modal.Header style={APPLICATION_INSTRUCTIONS_STYLES.modalHeader}>
        <div style={APPLICATION_INSTRUCTIONS_STYLES.headerContent}>
          <Modal.Title as="div" style={APPLICATION_INSTRUCTIONS_STYLES.titleWrap}>
            <div style={APPLICATION_INSTRUCTIONS_STYLES.headerIcon}>
              <i className="fa fa-info-circle" aria-hidden="true"></i>
            </div>
            <div>
              <div style={APPLICATION_INSTRUCTIONS_STYLES.title}>
                Help for Completing the Onboarding Process
              </div>
              <div style={APPLICATION_INSTRUCTIONS_STYLES.subtitle}>
                Review the required steps, timeline expectations, and portal features available during onboarding.
              </div>
            </div>
          </Modal.Title>

          <button
            type="button"
            style={APPLICATION_INSTRUCTIONS_STYLES.closeButton}
            onClick={handleInstructionShowHide}
            aria-label="Close application instructions popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={APPLICATION_INSTRUCTIONS_STYLES.modalBody}>
        <div style={APPLICATION_INSTRUCTIONS_STYLES.helperCard}>
          <div style={APPLICATION_INSTRUCTIONS_STYLES.helperTitle}>Onboarding overview</div>
          <p style={APPLICATION_INSTRUCTIONS_STYLES.helperText}>
            Complete each onboarding step in sequence, upload documents where requested,
            and use the status area in the portal to track progress without repeating work.
          </p>
        </div>

        <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionCard}>
          <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionTitle}>Onboarding process steps</div>
          <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionSubtitle}>
            Follow the checklist below to keep your onboarding moving smoothly.
          </div>
          <ol style={APPLICATION_INSTRUCTIONS_STYLES.numberList}>
            {steps.map((step, index) => (
              <li key={`${step.title}-${index}`}>
                <strong>{step.title}</strong> - {step.text}
              </li>
            ))}
          </ol>
        </div>

        <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionGrid}>
          <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionCard}>
            <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionTitle}>
              {isCandidate ? "Time log management" : "Time log management and invoicing"}
            </div>
            <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionSubtitle}>
              Use the portal as the primary workspace for hours, records, and supporting documents.
            </div>
            <div style={APPLICATION_INSTRUCTIONS_STYLES.infoCard}>
              <div style={APPLICATION_INSTRUCTIONS_STYLES.infoCardTitle}>What this section covers</div>
              <ul style={APPLICATION_INSTRUCTIONS_STYLES.bulletList}>
                {isCandidate ? (
                  <>
                    <li>Register weekly hours worked on the project.</li>
                    <li>Upload signed weekly or monthly timesheets in one place.</li>
                    <li>Your employer or recruiter can automatically view submitted hours and signed sheets.</li>
                    <li>You may still need to enter time in client-specific portals when required.</li>
                  </>
                ) : (
                  <>
                    <li>Review candidate work hours logged weekly or monthly.</li>
                    <li>Access submitted timesheets without asking candidates to email or fax them.</li>
                    <li>Upload invoices only for monthly invoicing to IPCS.</li>
                    <li>Raise invoices on time under net 30 payment expectations.</li>
                  </>
                )}
              </ul>
            </div>
          </div>

          <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionCard}>
            <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionTitle}>Additional portal features</div>
            <div style={APPLICATION_INSTRUCTIONS_STYLES.sectionSubtitle}>
              The portal supports collaboration beyond onboarding tasks.
            </div>
            <div style={APPLICATION_INSTRUCTIONS_STYLES.noteBox}>
              <div style={APPLICATION_INSTRUCTIONS_STYLES.noteTitle}>Portal note</div>
              <p style={APPLICATION_INSTRUCTIONS_STYLES.noteText}>
                {isCandidate
                  ? "You can use messages, alerts, and document exchange features to communicate electronically with IPCS about your project engagement. Your employer or recruiter also has access to the parts of the system relevant to their work, enabling real-time collaboration."
                  : "Use messages, alerts, and document exchange features to communicate with IPCS about contracts, purchase orders, contract extensions, ACH items, insurance certificates, and related engagement activity."}
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={APPLICATION_INSTRUCTIONS_STYLES.modalFooter}>
        <div style={APPLICATION_INSTRUCTIONS_STYLES.footerActions}>
          <button
            type="button"
            style={APPLICATION_INSTRUCTIONS_STYLES.cancelButton}
            onClick={() => handleInstructionShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ApplicationInstructions;
